export default "__VITE_ASSET__050232e3__"